import { rootStore } from './root-store';

/**
 * Новый кабинет (HKeeper 2.0) включён у отеля — поле
 * Platform.new_cabinet_enabled, выбирает суперадмин при активации.
 * Отели из пилотных списков (public/cockpit-r3.json и др.) получают
 * новый кабинет и без поля.
 */
export function platformNewCabinet(platformId?: number | null): boolean {
  const p = platformId
    ? rootStore.platforms.items.get(platformId)
    : rootStore.platforms.activePlatform;
  return p?.new_cabinet_enabled === true;
}

/**
 * Суперадмин и поддержка — в новом интерфейсе всегда, независимо от отеля
 * (решение 03.11.2026). Можно выключить для себя в меню профиля
 * («Старый интерфейс»); запоминается в этом браузере.
 */
const STAFF_LEGACY_KEY = 'hk-staff-legacy-shell';

export function staffPrefersLegacy(): boolean {
  try { return localStorage.getItem(STAFF_LEGACY_KEY) === '1'; } catch { return false; }
}

export function setStaffPrefersLegacy(on: boolean): void {
  try { on ? localStorage.setItem(STAFF_LEGACY_KEY, '1') : localStorage.removeItem(STAFF_LEGACY_KEY); } catch { /* без хранилища */ }
}

export function isStaffAccount(): boolean {
  const p = rootStore.profile as { is_superadmin?: boolean; is_support?: boolean } | null;
  return p?.is_superadmin === true || p?.is_support === true;
}
